import { Container } from "intraactive-sdk-helper";

declare global {
  interface Window {
    globalSdkContainerInstance: Container;
    globalSdkContainers: Record<string, Container>;
  }
}

export const sdkContainerInstance: Container = window.globalSdkContainerInstance
  ? window.globalSdkContainerInstance
  : (window.globalSdkContainerInstance = new Container());

export const getSdkContainer = (appId?: string): Container => {
  if (!appId) {
    return sdkContainerInstance;
  }

  if (!window.globalSdkContainers) {
    window.globalSdkContainers = {};
  }

  if (!window.globalSdkContainers[appId]) {
    window.globalSdkContainers[appId] = new Container();
  }

  return window.globalSdkContainers[appId];
};